// extracted by mini-css-extract-plugin
module.exports = {"container":"estatePartner_container__7iFWM","content":"estatePartner_content__3yohJ","img":"estatePartner_img__1GYPh","contentText":"estatePartner_contentText__1zzPv","subContent":"estatePartner_subContent__2H7Aa","title":"estatePartner_title__wfLMQ","text":"estatePartner_text__1wA7Q","hiddenDesktop":"estatePartner_hiddenDesktop__3nH8q","unCollapseHeight":"estatePartner_unCollapseHeight__3PR6d","hiddenMobile":"estatePartner_hiddenMobile__5tJHF"};
    if(module.hot) {
      // 1744882530626
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  